import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path, Circle } from '../IconBase/IconBase'

function Checked({
  fill = 'none',
  color = 'icon.greenCheck',
  strokeColor = 'white',
  ...props
}) {
  return (
    <IconBase viewBox='0 0 34 34' {...props}>
      <Circle cx='17' cy='17' r='17' fill={color} />
      <Path
        d='M24 12L14.7709 22L10 17.0318'
        stroke={strokeColor}
        strokeWidth='2.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
    </IconBase>
  )
}

Checked.propTypes = {
  color: PropTypes.string,
  strokeColor: PropTypes.string,
  fill: PropTypes.string,
}

export default Checked
